var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.product.attributes["variants-count"] > 1)?_c('p',{staticClass:"variant-count",domProps:{"textContent":_vm._s(((_vm.product.attributes["variants-count"]) + " " + _vm.productOptionType + "s"))}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }